import ApiRequest from "../utils/ApiRequest";
import Util from "../utils/Util";

export default class Users {
  getLoggedInUser = async () => {
    return await ApiRequest.set('/v1/user', "GET")
  }

  login = async (user) => {
    user.password = Util.hashSHA2(user.password)
    return await ApiRequest.set('/v1/users/login', "POST", user)
  }

  logout = async () => {
    return await ApiRequest.set('/v1/users/logout', "POST", {})
  }


  getAll = async () => {
    return await ApiRequest.set("/v1/users", "GET");
  };

  getById = async (id) => {
     return await ApiRequest.set("/v1/users/"+id, "GET");
  };

  create = async (user) =>{
    return await ApiRequest.set("/v1/users/create", "POST", user)
  }

  uploadTrainingFile = async (file) => {

    let formData = new FormData();

    console.log('blob', file)
    formData.append('upload', file, file.name);

    return await ApiRequest.setMultipart("/v1/audio/upload", "POST", formData)

  }

  createTraining = async (training) => {
    return await ApiRequest.set("/v1/training/dummy", "POST", training)
  }

}
